function addItemToCartRC(e, t, s, o) {
    data = {
        id: e,
        quantity: t,
        properties: {
            shipping_interval_frequency: s,
            shipping_interval_unit_type: o
        }
    }, jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function() {
            window.location = reChargeProcessCart()
        }
    })
}

function addItemToCart(e, t) {
    data = {
        id: e,
        quantity: t
    }, jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function() {
            window.location.href = "/checkout"
        }
    })
}

function addItemToCartCustom(e, t) {
    data = {
        id: e,
        quantity: t
    }, jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function() {
            window.location = reChargeProcessCart()
        }
    })
}

function reChargeProcessCart() {
    function e(e) {
        return (document.cookie.match("(^|; )" + e + "=([^;]*)") || 0)[2]
    }
    do token = e("cart"); while (void 0 == token);
    try {
        var t = ga.getAll()[0].get("linkerParam")
    } catch (s) {
        var t = ""
    }
    return "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=getmagicmind.myshopify.com&cart_token=" + token + "&" + t
}

function runSliders() {
    $(".step-grid-slider").slick({
        slidesToShow: 2,
        dots: !0,
        arrows: !1,
        infinite: !0,
        adaptiveHeight: !0,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !0,
                dots: !0
            }
        }]
    })
}

function testimonailSliders() {
    991 > $(window).width() ? $(".Product_Testimonials").not("slick-initialized").slick({
        slidesToShow: 2,
        dots: !0,
        arrows: !1,
        infinite: !0,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !0,
                dots: !0
            }
        }]
    }) : $(".Product_Testimonials").hasClass("slick-initialized") && $(".Product_Testimonials").slick("unslick")
}

function ajaxAddToCart(variantId, sellingPlanId = null) {
  console.log('run func')
  const data = {
    id: Number(variantId),
    quantity: 1
  };

  if (sellingPlanId) {
    data.selling_plan = Number(sellingPlanId);
  }

  console.log('Data to be sent:', data);

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(data),
    contentType: "application/json",
    dataType: "json",
    success: function(response) {
      console.log('Response data:', response);
      if (response.items && response.items.length > 0) {
        console.log('Success: Item(s) added to cart.');
      } else {
        console.log('No items were added to the cart.');
        if (response.message) {
          console.log('Shopify response message:', response.message);
        }
      }
    },
    error: function(xhr, status, error) {
      console.error('Error:', xhr.responseText);
      if (xhr.responseText.includes("Cannot apply selling plan to variant")) {
        console.log('The provided selling plan ID is not applicable to this variant.');
      } else if (xhr.responseText.includes("selling_plan")) {
        console.log('There was an issue with the selling plan ID.');
      } else {
        console.log('An unexpected error occurred.');
      }
    }
  });
}

function ajaxAddToCartCommon(variantId1, variantId2, variantId3, variantId4) {
  console.log('run func');

  const data = {
    items: [
      { id: Number(variantId1), quantity: 1 },
      { id: Number(variantId2), quantity: 1 },
      { id: Number(variantId3), quantity: 1 },
      { id: Number(variantId4), quantity: 1 }
    ]
  };

  console.log('Data to be sent:', data);

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(data),
    contentType: "application/json",
    dataType: "json",
    success: function(response) {
      console.log('Response data:', response);
      if (response.items && response.items.length > 0) {
        console.log('Success: Item(s) added to cart.');
      } else {
        console.log('No items were added to the cart.');
        if (response.message) {
          console.log('Shopify response message:', response.message);
        }
      }
    },
    error: function(xhr, status, error) {
      console.error('Error:', xhr.responseText);
      if (xhr.responseText.includes("Cannot apply selling plan to variant")) {
        console.log('The provided selling plan ID is not applicable to this variant.');
      } else if (xhr.responseText.includes("selling_plan")) {
        console.log('There was an issue with the selling plan ID.');
      } else {
        console.log('An unexpected error occurred.');
      }
    }
  });
}

$(document).on("click",".m-rews-text",function() {
    $("html, body").animate({
        scrollTop: $(".Product_Reviews").offset().top
    }, 2e3)
});

$(document).on("click", ".mob-menu-link", function() {
  $(this).closest('.mob-sub-wrap').toggleClass('m-active')
  $(this).closest('.mob-sub-wrap').find('.mob-submenu').slideToggle()
});

$(document).on("click",".js-tab",function() {
    let tabHead = $(this);

    if (tabHead.hasClass('js-left')) {
        $('.js-left-tab').show()
        // $('.js-right-tab').hide()
        $('.js-right-tab').addClass('m-hide-tab');
        $('.js-tab').removeClass('active');
        $(this).addClass('active');
        $('.learn-ingredients-tabs .m-tabs-head').removeClass('right-active');
        $('.learn-ingredients-tabs .m-tabs-head').addClass('left-active');
        $('.js-right-tab-image').removeClass('active');
        $('.js-left-tab-image').addClass('active');

    }
    if (tabHead.hasClass('js-right')) {
        // $('.js-right-tab').show()
        $('.js-right-tab').removeClass('m-hide-tab');
        $('.js-left-tab').hide()
        $('.js-tab').removeClass('active');
        $(this).addClass('active');
        $('.learn-ingredients-tabs .m-tabs-head').removeClass('left-active');
        $('.learn-ingredients-tabs .m-tabs-head').addClass('right-active');
        $('.js-left-tab-image').removeClass('active');
        $('.js-right-tab-image').addClass('active');
    }
});
  

$(document).on("click",'[data-button="30-sub-sleep"]',function(e) {
  e.preventDefault();
  console.log(11)
  ajaxAddToCart(41154605875334, 3027894406);
});


$(document).on("click",".js-scroll-top",function(e) {
  e.preventDefault();
  $("html, body").animate({ scrollTop: 0 }, 1000);
});

function setEqualHeight(e) {
    var t = 0;
    e.each(function() {
        (currentHeight = $(this).height()) > t && (t = currentHeight)
    }), e.height(t)
}
 
$(document).ready(function() {
    $("#firstToggle").next().show(), $(".ingredients-wrapper-card-title").click(function(e) {
        var t = $(this).closest(".ingredients-wrapper-card").find(".ingredients-wrapper-card-panel");
        $(this).closest(".ingredients-wrapper-mobile").find(".ingredients-wrapper-card-panel").not(t).slideUp(), $(this).hasClass("active") ? $(this).removeClass("active") : ($(this).closest(".ingredients-wrapper-mobile").find(".ingredients-wrapper-card-title.active").removeClass("active"), $(this).addClass("active")), t.stop(!1, !0).slideToggle(), e.preventDefault()
    })

  
    var firstClick = true;
    
     if ($(window).width() <= 991 && firstClick) {
        $('.ingredients-flex-child.js-right-tab .ingredient-dropdown.w-dropdown .ingredient-pane.w-dropdown-list').hide()
       firstClick = false;
    }

}), $(".faq-toggle").click(function() {
    var e = $(this).parent(),
        t = $(this).siblings(".faq-list");
    e.hasClass("active") ? (e.removeClass("active"), t.slideUp()) : (e.addClass("active"), t.slideDown())
}), $(".ingredient-dropdown").mouseenter(function() {
    $(".slide-out-ingredient").removeClass("active"), $(".ingredient-pane").slideUp(200), $(this).siblings(".ingredient-pane").slideDown(200), $(this).children(".slide-out-ingredient").addClass("active")
}), $(".ingredient-dropdown").mouseleave(function() {
    $(this).siblings(".ingredient-pane").slideUp(200), $(this).children(".slide-out-ingredient").removeClass("active")
}), $(".ingredient-dropdown").mouseenter(function() {
    $(this).children(".ingredient-pane").slideDown(200), $(this).find(".slide-out-ingredient").addClass("active")
}), $(".ingredient-dropdown").mouseleave(function() {
    $(this).children(".ingredient-pane").slideUp(200), $(this).find(".slide-out-ingredient").removeClass("active")
}), $(".hamburger-wrapper").click(function() {
    if ($('.mob-sub-wrap').hasClass('m-active')) {
     // $('.mob-menu-link').trigger('click');
      console.log('ssss')
    }
    $(this).hasClass("active") ? ($(this).removeClass("active"), $(".hamburer-line.top-bun").css("transform", "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"), $(".hamburer-line.patty").css("display", "block"), $(".hamburer-line.bottom-bun").css("transform", "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"), $(".hamburger-wrapper .mobile-menu").css("transform", "translate3d(125%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"), setTimeout(function() {
        $(".hamburger-wrapper .mobile-menu").css("display", "none")
    }, 200)) : ($(this).addClass("active"), $(".hamburer-line.top-bun").css("transform", "translate3d(0px, 2px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(45deg) skew(0deg, 0deg)"), $(".hamburer-line.patty").css("display", "none"), $(".hamburer-line.bottom-bun").css("transform", "translate3d(0px, -2px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-45deg) skew(0deg, 0deg)"), $(".hamburger-wrapper .mobile-menu").css("display", "flex"), setTimeout(function() {
        $(".hamburger-wrapper .mobile-menu").css("transform", "translate3d(0%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)")
    }, 50))
}), $(window).scroll(function() {
    768 > $(window).width() && ($(window).scrollTop() > 1 ? $(".header").addClass("active") : $(".header").removeClass("active"))
}), $(".tab-link").click(function() {
    let e = $(this).data("w-tab");
    console.log($(".tab-pane").data("w-tab", `${e}`)), $(".tab-link").removeClass("w--current"), $(".tab-pane").removeClass("w--tab-active"), $(this).addClass("w--current"), $(`.tab-pane[data-w-tab='${e}']`).addClass("w--tab-active")
}), $(".custom-add-to-cart").click(function(e) {
    console.log("af");
    let t = !1;
    jQuery.getJSON("/cart.js", function(e) {
        for (i = 0; i < e.items.length; i++)
            if (e.items[i].properties && e.items[i].properties.shipping_interval_frequency) {
                t = !0;
                break
            } let s, o, a = $(".rc_block__type--active").find("input[name='purchase_type']").val();
        "31346177835142" == new URLSearchParams(window.location.search).get("variant") || null == new URLSearchParams(window.location.search).get("variant") ? (o = 31376632971398, s = 31346177835142) : "31346177867910" == new URLSearchParams(window.location.search).get("variant") && (s = 31346177867910, o = 31376633004166), "autodeliver" == a ? addItemToCartRC(o, 1, "1", "Months") : t ? addItemToCartCustom(s, 1) : addItemToCart(s, 1)
    })
}), $(".rc_block__type__onetime").click(function() {
    $(".rc_popup").hide(), $(".rc_label__deliver_every").hide(), 768 > $(window).width() ? $("#rc_radio_options").css("grid-gap", "68px") : $("#rc_radio_options").css("grid-gap", "16px")
}), $(".rc_block__type__autodeliver").click(function() {
    $(".rc_popup").show(), $(".rc_label__deliver_every").show(), 768 > $(window).width() ? $("#rc_radio_options").css("grid-gap", "200px") : $("#rc_radio_options").css("grid-gap", "16px")
}), $(".SizeSwatch").click(function() {
    $(".rc_block__type__onetime").hasClass("rc_block__type--active") ? ($(".rc_popup").hide(), 768 > $(window).width() ? $("#rc_radio_options").css("grid-gap", "68px") : $("#rc_radio_options").css("grid-gap", "16px")) : ($(".rc_popup").show(), 768 > $(window).width() ? $("#rc_radio_options").css("grid-gap", "200px") : $("#rc_radio_options").css("grid-gap", "16px")), $(".SizeSwatch").removeClass("activeSub"), $(this).addClass("activeSub")
}), $(".checkout-routing").click(function(e) {
    e.preventDefault();
    let t = !1;
    jQuery.getJSON("/cart.js", function(e) {
        for (let s = 0; s < e.items.length; s++)
            if (e.items[s].properties && e.items[s].properties.shipping_interval_frequency) {
                t = !0;
                break
            } console.log(t), t ? window.location = reChargeProcessCart() : window.location.href = "/checkout"
    })
}), $(".sub-addtocart").click(function() {
    let e = $(".SizeSwatch.activeSub").text();
    console.log(e), "15 Bottles" == e ? addItemToCartRC(31376632971398, 1, "1", "Months") : addItemToCartRC(31376633004166, 1, "1", "Months")
}), $(document).ready(function() {
    $(".scrolling__marquee").slick({
        speed: 4e3,
        autoplay: !0,
        autoplaySpeed: 0,
        centerMode: !1,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: !0,
        infinite: !0,
        initialSlide: 1,
        arrows: !1,
        buttons: !1,
        pauseOnFocus: !1,
        pauseOnHover: !1,
        swipe: !1,
        touchMove: !1
    }), $(".Productivity_Video_Slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !0,
        arrows: !0,
        responsive: [{
            breakpoint: 991,
            settings: {
                arrows: !1
            }
        }]
    })
}), $(".Ingredients_Title").each(function() {
    $(this).mouseenter(function(e) {
        var t = $(this).index();
        $(this).addClass("active"), $(".Ingredients_Details_Wrapper").each(function() {
            var e = $(this).index();
            console.log(e), t == e ? $(this).show() : $(this).hide()
        })
    }), $(this).mouseleave(function(e) {
        $(this).index(), $(this).removeClass("active")
    })
}), $(document).ready(function() {
    var e = $(".Product_Faq_Wrapper .faq-child").length,
        t = 5;
    // $(".Product_Faq_Wrapper .faq-child:lt(" + t + ")").show(), $(".See_More").click(function() {
    //     t = e, "See more" == $(this).text() ? ($(this).text("See less"), $(".Product_Faq_Wrapper .faq-child:lt(" + t + ")").show()) : ($(this).text("See more"), $(".Product_Faq_Wrapper .faq-child:gt(4)").hide())
    // })
}), $(window).scroll(function(e) {
    var t = $(window).height() / 3,
        s = $(window).scrollTop() + t + $("#shopify-section-custom-header").outerHeight(!0),
        o = s + t;
    $(".Productivity_Video_Wrap").each(function() {
        var e = $(this).offset().top;
        e + $(this).outerHeight(!0) < s || e > o ? (this.pause(), $(this).prop("muted", !0), $(this).siblings(".Productivity_Video_Controls").find(".Audio_Mute").removeClass("unmute-video")) : (this.play(), $(this).prop("muted", !0), $(this).siblings(".Productivity_Video_Controls").find(".Audio_Mute").removeClass("unmute-video"))
    })
}), $("body").on("click", ".Audio_Mute", function() {
    $(this).parents(".Productivity_Video_Controls").siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop("muted") ? ($(this).parents(".Productivity_Video_Controls").siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop("muted", !1), $(this).addClass("unmute-video")) : ($(this).parents(".Productivity_Video_Controls").siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop("muted", !0), $(this).removeClass("unmute-video"))
}), $(window).on("load resize orientationchange", function(e) {
    runSliders(), testimonailSliders()
}), $(document).ready(function() {
    runSliders(), testimonailSliders()
}), $(".Productivity_Video_Slider").on("afterChange", function(e, t, s, o) {
    $(".slick-active").find(".Productivity_Video_Wrap")[0].play(), $(".Productivity_Video_Controls").siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop("muted", !0), $(".Audio_Mute").removeClass("unmute-video")
}), $(".Productivity_Video_Slider").on("beforeChange", function(e, {
    slideCount: t
}, s, o) {
    $(".Productivity_Video_Wrap").each(function() {
        this.pause(), $(this).find(".Productivity_Video_Controls").siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop("muted", !0), $(this).find(".Audio_Mute").removeClass("unmute-video")
    })
});
var delay = function() {
    var e = 0;
    return function(t, s) {
        clearTimeout(e), e = setTimeout(t, s)
    }
}();

function inViewport() {
    var e = $("#shopify-section-product-template")[0];
    e ? e.getBoundingClientRect().bottom - 100 < 0 ? $(".Sticky_Bar").addClass("Fixed") : $(".Sticky_Bar").removeClass("Fixed") : console.warn("Element #shopify-section-product-template not found")
}
$(window).resize(function() {
    $(".Product_Page_Reviews .testimonial-card-top").css("height", "auto"), setEqualHeight($(".Product_Page_Reviews .testimonial-card-top")), $(".Reasons_Hero_Icons").css("height", "auto"), setEqualHeight($(".Reasons_Hero_Icons")), $(".Reasons_Icons").css("height", "auto"), setEqualHeight($(".Reasons_Icons"))
}), $(document).ready(function() {
    $(".Product_Page_Reviews .testimonial-card-top").css("height", "auto"), setEqualHeight($(".Product_Page_Reviews .testimonial-card-top")), $(".Reasons_Hero_Icons").css("height", "auto"), setEqualHeight($(".Reasons_Hero_Icons")), $(".Reasons_Icons").css("height", "auto"), setEqualHeight($(".Reasons_Icons"))
}), $(window).scroll(function() {
    inViewport()
}), $(window).resize(function() {
    inViewport()
}), $(".ingredients-tab ul li").click(function() {
    $("html, body").animate({
        scrollTop: $("#shopify-section-product-ingredients").offset().top - 100
    }, 2e3)
}), $(".jdgm-all-reviews-widget").click(function() {
    $("html, body").animate({
        scrollTop: $("#shopify-section-product-reviews").offset().top - 100
    }, 2e3)
}),
  $(document).ready(function(){
  $(".Reasons_Testimonials_Inner").slick({
    slidesToShow: 1,
    dots: !0,
    arrows: !0,
    infinite: !0,
    adaptiveHeight: !0,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: !1
        }
    }]
});
    }), $(".Days_Carousel").slick({
    slidesToShow: 1,
    dots: !0,
    arrows: !1,
    infinite: !0,
    adaptiveHeight: !0,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: !1
        }
    }]
}), $(".Steps_Carousel_Inner").slick({
    slidesToShow: 1,
    dots: !0,
    arrows: !0,
    infinite: !0,
    adaptiveHeight: !0,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: !1
        }
    }]
});

//EBOOK JS COMPONENTS
/* MARQUEE SLIDER */

$(document).ready(function() {
  $('.scrolling__marquee').not('.slick-initialized').slick({
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    swipe: false,
    touchMove: false
  });

  $('.Productivity_Video_Slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false
		}
      }
	]
  });

});

/* CHANGE INGREDIENTS CONTENT ON HOVER */

$(".Ingredients_Title" ).each(function() {
  $(this).mouseenter(function(index) {
     var index1 = $(this).index();
     $(this).addClass('active');

    $(".Ingredients_Details_Wrapper" ).each(function() { 
      var index2 = $(this).index();
      console.log(index2);
      
      if (index1 == index2) {
        $(this).show();
      }
      else {
        $(this).hide();
      }
    });
  });
  
  $(this).mouseleave(function(index) {
    var index1 = $(this).index();
    $(this).removeClass('active');
  });
  
});

/* FAQ READ MORE */

$(document).ready(function () {
  var size_li = $(".Product_Faq_Wrapper .faq-child").length;
  var x = 5;

  if ($('.metaobject-content').length) {
    x = 100;
  }

  $('.Product_Faq_Wrapper .faq-child:lt('+x+')').show();

  /*---/ Wil's -- fix 9/7 /---*/
  document.querySelectorAll('.See_More').forEach(function(seeMoreBtn) {
    seeMoreBtn.addEventListener('click', function() {
      let x = size_li;
  
      let faqChildren = document.querySelectorAll('.Product_Faq_Wrapper .faq-child');
  
      if (this.textContent == "See more") {
        this.textContent = "See less";
        faqChildren.forEach(function(child, index) {
          if (index < x) {
            child.style.display = 'block';
          }
        });
      } else {
        this.textContent = "See more";
        faqChildren.forEach(function(child, index) {
          if (index > 4) {
            child.style.display = 'none';
          }
        });
      }
    });
  });

  /*---//---*/

  
  // $('.See_More').click(function () {
  //   x = size_li;

    
    
  //   if ($(this).text() == "See more") { 
  //     $(this).text("See less"); 
  //     $('.Product_Faq_Wrapper .faq-child:lt('+x+')').show();
  //   } else { 
  //     $(this).text("See more"); 
  //     $('.Product_Faq_Wrapper .faq-child:gt(4)').hide();
  //   }; 

  // });
});

/* PLAY VIDEO ON SCROLL */

$(window).scroll(function(e)         {
  var offsetRange = $(window).height() / 3,
      offsetTop = $(window).scrollTop() + offsetRange + $("#shopify-section-custom-header").outerHeight(true),
      offsetBottom = offsetTop + offsetRange;

  $(".Productivity_Video_Wrap").each(function() { 
    var y1 = $(this).offset().top;
    var y2 = offsetTop;
    if (y1 + $(this).outerHeight(true) < y2 || y1 > offsetBottom) {
     this.pause();
     $(this).prop('muted', true);
     $(this).siblings('.Productivity_Video_Controls').find('.Audio_Mute').removeClass('unmute-video');

    }
    else {
      this.play();
      $(this).prop('muted', true);
      $(this).siblings('.Productivity_Video_Controls').find('.Audio_Mute').removeClass('unmute-video');
    }
  });
});

/* MUTE VIDEO ON CLICK */

$('body').on('click', '.Audio_Mute', function() {
  if ($(this).parents('.Productivity_Video_Controls').siblings(".Productivity_Video_Main_Wrap").find('.Productivity_Video_Wrap').prop('muted') ) {
    $(this).parents('.Productivity_Video_Controls').siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop('muted', false);
    $(this).addClass('unmute-video'); 
  } else {
    $(this).parents('.Productivity_Video_Controls').siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop('muted', true);
    $(this).removeClass('unmute-video');
  }
});

$('body').on('click', '.Audio_Mute', function() {
  var videoElement = $(this).closest('.Productivity_Video_Main').find('.Productivity_Video_Wrap')[0]; // Directly find the video element
  if (videoElement.muted) { // Check if the video is muted
    videoElement.muted = false; // Unmute the video
    $(this).addClass('unmute-video'); // Add class for styling if needed
  } else {
    videoElement.muted = true; // Mute the video
    $(this).removeClass('unmute-video'); // Remove class for styling if needed
  }
});


/* SLIDER */

function runSliders() {
//   if($(window).width() < 991) {
    $(".step-grid-slider").not('.slick-initialized').slick({
      slidesToShow: 2,
      dots: true,
      arrows: false,
      infinite: true,
	  adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ]
    })
//   }
  
//   else {
//     if($(".testimonial-grid").hasClass('slick-initialized')){
//       $(".testimonial-grid").slick('unslick');
//     }

//     if($(".step-grid").hasClass('slick-initialized')){
//       $(".step-grid").slick('unslick');
//     }
//   }	

}

/* TESTIMONIAL SLIDER */

function testimonailSliders() {

  if($(window).width() < 991) {
    
    $(".Product_Testimonials").not('slick-initialized').slick({
      slidesToShow: 2,
      dots: true,
      arrows: false,
      infinite: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }
        ]
    })
  }
  else {
    if($(".Product_Testimonials").hasClass('slick-initialized')){
      $(".Product_Testimonials").slick('unslick');
    }
  }

//   var slickHeight = $(".Product_Page_Reviews .slick-track").outerHeight();

//   var slideHeight = $(".Product_Page_Reviews .slick-track").find(".slick-slide").outerHeight();

//   function resizeSlider() {
//     $(".Product_Page_Reviews .slick-track")
//     .find(".Product_Page_Reviews .slick-slide .slide-wrap")
//     .css("height", slickHeight + "px");
//   }
}

$(window).on("load resize orientationchange", function(event) {
  runSliders();
  testimonailSliders();
});

$(window).on("load", function() {
    setTimeout(function(){
        if ($('.Product__Info .ProductForm__AddToCart').prop("disabled") == true) {
            $('.Product__Info .ProductForm__AddToCart').prop("disabled", false);
        }
    }, 1000);
});
  

$(document).ready(function () {
  runSliders();
  testimonailSliders();  
});

/* PLAY VIDEO ON SLIDE CHANGE */

$('.Productivity_Video_Slider').on('afterChange', function(event, slick, currentSlide,nextSlide){
  $('.slick-active').find('.Productivity_Video_Wrap')[0].play();
  $('.Productivity_Video_Controls').siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop('muted', true);
  $(".Audio_Mute").removeClass('unmute-video');
});

$('.Productivity_Video_Slider').on('beforeChange', function(event, { slideCount: count }, currentSlide, nextSlide){
  $('.Productivity_Video_Wrap').each(function() {
    this.pause();
    $(this).find('.Productivity_Video_Controls').siblings(".Productivity_Video_Main_Wrap").find(".Productivity_Video_Wrap").prop('muted', true);
    $(this).find(".Audio_Mute").removeClass('unmute-video');        
  });
});


/* TESTIMONIALS TITLE EQUAL HEIGHT */

function setEqualHeight(columns) {
  var tallestcolumn = 0;
  columns.each(
    function() {
      currentHeight = $(this).height();
      if(currentHeight > tallestcolumn) {
        tallestcolumn  = currentHeight;
      }
    }
  );
  columns.height(tallestcolumn);
}
var delay = (function(){
  var timer = 0;
  return function(callback, ms){
    clearTimeout (timer);
    timer = setTimeout(callback, ms);
  };
})();

$(window).resize(function() {
  $('.Product_Page_Reviews .testimonial-card-top').css('height','auto'); //solve for all you browser stretchers out there!
  setEqualHeight($('.Product_Page_Reviews .testimonial-card-top'));
 
  $('.Reasons_Hero_Icons').css('height','auto'); //solve for all you browser stretchers out there!
  setEqualHeight($('.Reasons_Hero_Icons'));

  $('.Reasons_Icons').css('height','auto'); //solve for all you browser stretchers out there!
  setEqualHeight($('.Reasons_Icons'));
  
});

$(document).ready(function() {
  $('.Product_Page_Reviews .testimonial-card-top').css('height','auto'); //solve for all you browser stretchers out there!
  setEqualHeight($('.Product_Page_Reviews .testimonial-card-top'));
  
  $('.Reasons_Hero_Icons').css('height','auto'); //solve for all you browser stretchers out there!
  setEqualHeight($('.Reasons_Hero_Icons'));

  $('.Reasons_Icons').css('height','auto'); //solve for all you browser stretchers out there!
  setEqualHeight($('.Reasons_Icons'));

  if ($(".ingredients-v4-slider").length) {
    $(".ingredients-v4-slider").slick({
      dots: !0,
      arrows: !0,
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [{
          breakpoint: 991,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
      }, {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      }]
    })
  }
});

// Fixed Product Bar

function inViewport(){ 
  if ($("#shopify-section-product-template")[0]?.getBoundingClientRect().bottom - 100 < 0){
    $('.Sticky_Bar').addClass('Fixed');
  }
  else {
    $('.Sticky_Bar').removeClass('Fixed');
  }
}

$(window).scroll(function() {
  inViewport();
});

$(window).resize(function(){
  inViewport();
});


// $('.ingredients-tab ul li').click(function() {
//   $('html, body').animate({
//     scrollTop: $("#shopify-section-product-ingredients").offset().top - 100
//   }, 2000);
// })

// $('.jdgm-all-reviews-widget').click(function() {
//     $('html, body').animate({
//     scrollTop: $("#shopify-section-product-reviews").offset().top - 100
//   }, 2000);
// })

// $(".Reasons_Testimonials_Inner").slick({
//   slidesToShow: 1,
//   dots: false,
//   arrows: true,
//   infinite: true,
//   adaptiveHeight: true
// })

// $(".Days_Carousel").slick({
//   slidesToShow: 1,
//   dots: true,
//   arrows: false,
//   infinite: true,
//   adaptiveHeight: true,
//   responsive: [
//   {
//     breakpoint: 768,
//     settings: {
//       arrows: false
//     }
//   }
// ]
// })

// $(".Steps_Carousel_Inner").slick({
//   slidesToShow: 1,
//   dots: true,
//   arrows: true,
//   infinite: true,
//   adaptiveHeight: true,
//   responsive: [
//   {
//     breakpoint: 768,
//     settings: {
//       arrows: false
//     }
//   }
// ]
// })


// $('.up-sell-slider').slick({      
//   slidesToShow: 6,
//   slidesToScroll: 1,
//   infinite: true,
//   speed: 1500,
//   autoplay: true,
//   autoplaySpeed: 0,
//   cssEase: 'linear',
//   variableWidth: true,
//   prevArrow: false,
//   nextArrow: false
// });


// $('.ingredients-v4-slider').slick({
//   dots: true,
//   arrows: true,
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 991,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]

// });

// FAQ
$(document).ready(function() {
  function loyaltyTiers() {
    $(document).on('click', '.loyalty-tiers__tab__title', function() {
      const $list = $(this).closest('.loyalty-tiers__tabs');
      const $item = $(this).closest('.loyalty-tiers__tab');
      const $content = $item.find('.loyalty-tiers__tab__content');
      
      $list.find('.loyalty-tiers__tab').not($item).find('.loyalty-tiers__tab__content').slideUp();
      $content.slideToggle();
    });
  }

  if($('.loyalty-tiers').length) {
    loyaltyTiers();
  }

  $(document).on('click', '.faq-block__item__head', function() {
    const item = $(this).closest('.faq-block__item');
    const answer = $(item).find('.faq-block__item__answer');

    $(item).toggleClass('active');
    $(answer).slideToggle(300);
  });
});
